<template>
    <div class="xl:flex print-break-avoid md-chart-wrapper__cols">
        <div class="xl:w-54/100 xxl:w-3/5 mb-6 xl:pr-8 mobile-order md-chart-wrapper__chart">
            
            <market-data-select :type="type"></market-data-select>

            <h2 class="pt-0 my-4">Marketing Year Total</h2>

            <div v-if="type == 'commodities' && marketDataMode == 'USDA-data'" class="flex items-center text-xs md:text-sm my-8 no-print">
                <div>Show Value (USD)</div>
                <div class='mg-toggle mx-4'>
                    <input id='valueQtyToggle' type='checkbox' v-model="qtyOption">
                    <label for='valueQtyToggle'>
                        <span class="invisible">Show export quantities?</span>
                    </label>
                </div>
                <div>Show Quantity ({{activeUnit}})</div>
            </div>

            <div v-if="type == 'top-export-partners'" class="hidden xl:flex items-center text-xs md:text-sm my-8 no-print">
                <div>Hide Dollar Values</div>
                <div class='mg-toggle mx-4'>
                    <input id='dollarToggle' type='checkbox' v-model="dollarsOption">
                    <label for='dollarToggle'>
                        <span class="invisible">Show dollar values?</span>
                    </label>
                </div>
                <div>Show Dollar Values</div>
            </div>

            <canvas id="market-data-chart" class="mt-8 mb-4"></canvas>

            <div v-if="(activeMarket || topTenMarkets.length) && export_totals" class="hidden md:block mt-2 mb-8 text-xs ml-4 font-semibold md-chart-wrapper__legend">
                <div v-for="(item, index) in activeChartItems" :key="index" v-if="type == 'commodities' && activeMarket[item]" class="flex -mr-4">
                    <div v-for="i in 5" :key="i" class="w-1/5">
                        <div class="p-1 relative border" :class="{'border-r-0': i != 5}" :style="{'border-color': legendItemColor(item)}">
                            <div :style="{'background-color': legendItemColor(item)}" class="pin absolute opacity-25"></div>
                            
                            <span class="no-print round w-2 h-2 inline-block mr-1" :style="{'background-color': legendItemColor(item)}"></span>
                            {{formatNumber(activeMarket[item][`year_${i}_quantity`])}}
                            <br>
                            <span class="no-print round w-2 h-2 inline-block mr-1" :style="{'background-color': legendItemColor(item)}"></span>
                            ${{formatNumber(activeMarket[item][`year_${i}_value`])}}
                        </div>
                    </div>
                </div>

                <div v-if="type == 'top-export-partners' && activeChartItems.indexOf('World Total') > -1" class="flex -mr-4">
                    <div v-for="i in 5" :key="i" class="w-1/5">
                        <div class="p-1 relative border" :class="{'border-r-0': i != 5}" :style="{'border-color': legendItemColor('World Total')}">
                            <div :style="{'background-color': legendItemColor('World Total')}" class="pin absolute opacity-25"></div>
                            
                            <span class="no-print round w-2 h-2 inline-block mr-1" :style="{'background-color': legendItemColor('World Total')}"></span>
                            {{formatNumber(export_totals[top_exports_selected][`year_${i}_quantity`])}}
                            <br>
                            <span class="no-print round w-2 h-2 inline-block mr-1" :style="{'background-color': legendItemColor('World Total')}"></span>
                            ${{formatNumber(export_totals[top_exports_selected][`year_${i}_value`])}}
                        </div>
                    </div>
                </div>

                <div v-for="(item, index) in topTenMarkets" :key="index" v-if="type == 'top-export-partners' && activeChartItems.indexOf(item.market_name) > -1" class="flex -mr-4">
                    <div v-for="i in 5" :key="i" class="w-1/5">
                        <div class="p-1 relative border" :class="{'border-r-0': i != 5}" :style="{'border-color': legendItemColor(item.market_name)}">
                            <div :style="{'background-color': legendItemColor(item.market_name)}" class="pin absolute opacity-25"></div>
                            
                            <span class="no-print round w-2 h-2 inline-block mr-1" :style="{'background-color': legendItemColor(item.market_name)}"></span>
                            {{formatNumber(item[top_exports_selected][`year_${i}_quantity`])}}
                            <br>
                            <span class="no-print round w-2 h-2 inline-block mr-1" :style="{'background-color': legendItemColor(item.market_name)}"></span>
                            ${{formatNumber(item[top_exports_selected][`year_${i}_value`])}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="flex-1">
            <market-data-commodities v-if="type == 'commodities'" :data="activeMarket"></market-data-commodities>
            <market-data-partners v-if="type == 'top-export-partners'"></market-data-partners>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import formatNumber from "../utilities/format-number";
import getQueryParam from "../utilities/get-query-param";

import numeral from "numeral";

import MarketDataSelect from "@/vue-components/market-data-select";
import MarketDataCommodities from "@/vue-components/market-data-commodities";
import MarketDataPartners from "@/vue-components/market-data-partners";

export default {
    props: ["type"],
    name: "market-data-chart",
    components: {
        "market-data-select": MarketDataSelect,
        "market-data-commodities": MarketDataCommodities,
        "market-data-partners": MarketDataPartners
    },
    data() {
        return {
            config: {
                type: "line",
                data: {
                    labels: [],
                    datasets: []
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    title: {
                        display: false,
                        text: "Chart.js Line Chart"
                    },
                    tooltips: {
                        mode: "index",
                        intersect: false,
                        titleFontColor: "#402f15",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        xPadding: 8,
                        yPadding: 8,
                        cornerRadius: 0,
                        borderColor: "#ccc",
                        borderWidth: 1,
                        callbacks: {
                            labelTextColor: function(tooltipItem, chart) {
                                return "#402f15";
                            },
                            label: function(tooltipItem, data) {
                                return (
                                    data.datasets[tooltipItem.datasetIndex]
                                        .label +
                                    ": " +
                                    numeral(tooltipItem.yLabel).format("0,0")
                                );
                            }
                        }
                    },
                    hover: {
                        mode: "nearest",
                        intersect: true
                    },
                    scales: {
                        xAxes: [
                            {
                                display: true,
                                scaleLabel: {
                                    display: false,
                                    labelString: "Year"
                                }
                            }
                        ],
                        yAxes: [
                            {
                                display: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: "Quantity"
                                },
                                ticks: {
                                    callback: function(value) {
                                        if (
                                            parseInt(value) &&
                                            parseInt(value).toString().length >
                                                3
                                        ) {
                                            return numeral(value)
                                                .format("0.00a")
                                                .toUpperCase();
                                        } else {
                                            return numeral(value)
                                                .format("0a")
                                                .toUpperCase();
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        };
    },
    computed: {
        ...mapState([
            "colors",
            "showQty",
            "showDollars",
            "activeUnit",
            "marketDataMode",
            "marketDataYears",
            "marketDataSettings",
            "market_data",
            "activeMarket",
            "commodities",
            "activeCommodities",
            "top_exports_selected",
            "selectedMarket",
            "export_totals",
            "activePartners"
        ]),
        ...mapGetters(["getCommodityProperty", "topTenMarkets"]),
        qtyOption: {
            get() {
                return this.showQty;
            },
            set(value) {
                this.updateQtyOption(value);
            }
        },
        dollarsOption: {
            get() {
                return this.showDollars;
            },
            set(value) {
                this.updateDollarsOption(value);
            }
        },
        activeChartItems() {
            if (this.type == "commodities") {
                return this.activeCommodities.sort();
            } else {
                return this.activePartners;
            }
        },
        marketYear() {
            return this.marketDataSettings.current_market_year;
        }
    },
    watch: {
        marketDataSettings() {
            this.addChartLabels();
        },
        showQty() {
            this.updateChartData();
        },
        topTenMarkets() {
            this.updateChartData();
        },
        top_exports_selected() {
            this.updateChartData();
        },
        activeMarket() {
            this.updateChartData();
        },
        activeChartItems() {
            this.updateChartData();
        },
        marketDataMode() {
            this.updateChartData();
        }
    },
    methods: {
        ...mapMutations([
            "setMarketDataView",
            "updateQtyOption",
            "setSelectedMarket",
            "updateDollarsOption"
        ]),
        ...mapActions(["handleActiveUnit"]),
        formatNumber: formatNumber,
        legendItemColor(item) {
            if (this.type == "commodities") {
                return this.getCommodityProperty({
                    key: item,
                    property: "color"
                });
            } else {
                if (item == "World Total") {
                    return this.colors[0];
                } else {
                    for (
                        let index = 0;
                        index < this.topTenMarkets.length;
                        index++
                    ) {
                        const partner = this.topTenMarkets[index];
                        if (item == partner.market_name) {
                            return this.colors[index + 1];
                        }
                    }
                }
            }
        },
        updateChartData() {
            this.handleActiveUnit();

            if (this.type == "commodities") {
                this.updateCommoditiesDatasets();
            } else if (this.type == "top-export-partners") {
                this.updatePartnersDatasets();
            }
        },
        updatePartnersDatasets() {
            if (this.topTenMarkets.length == 0 || !this.export_totals) {
                return;
            }

            const exportTotalProp = this.export_totals[
                this.top_exports_selected
            ];

            this.config.data.datasets = [];

            this.activeChartItems.forEach((item, index) => {
                if (item == "World Total") {
                    let dataset = {
                        label: item,
                        backgroundColor: this.colors[0],
                        borderColor: this.colors[0],
                        data: [],
                        fill: false
                    };
                    for (var year = 1; year <= this.marketDataYears; year++) {
                        if (this.showQty) {
                            dataset.data.push(
                                exportTotalProp[`year_${year}_quantity`]
                            );
                        } else {
                            dataset.data.push(
                                exportTotalProp[`year_${year}_value`]
                            );
                        }
                    }

                    this.config.data.datasets.push(dataset);
                } else {
                    for (
                        let partnerIndex = 0;
                        partnerIndex < this.topTenMarkets.length;
                        partnerIndex++
                    ) {
                        const partner = this.topTenMarkets[partnerIndex];
                        if (partner.market_name == item) {
                            let dataset = {
                                label: item,
                                backgroundColor: this.colors[partnerIndex + 1],
                                borderColor: this.colors[partnerIndex + 1],
                                data: [],
                                fill: false
                            };

                            for (
                                var year = 1;
                                year <= this.marketDataYears;
                                year++
                            ) {
                                if (this.showQty) {
                                    dataset.data.push(
                                        partner[this.top_exports_selected][
                                            `year_${year}_quantity`
                                        ]
                                    );
                                } else {
                                    dataset.data.push(
                                        partner[this.top_exports_selected][
                                            `year_${year}_value`
                                        ]
                                    );
                                }
                            }

                            this.config.data.datasets.push(dataset);

                            break;
                        }
                    }
                }
            });

            let yAxesLabel = window.mgChart.options.scales.yAxes[0];

            if (this.showQty) {
                yAxesLabel.scaleLabel.labelString = `Quantity (${
                    this.activeUnit
                })`;
            } else {
                yAxesLabel.scaleLabel.labelString = `Value`;
            }

            window.mgChart.update();
        },
        updateCommoditiesDatasets() {
            if (!this.activeMarket) return;

            this.config.data.datasets = [];

            this.activeChartItems.forEach(item => {
                const activeItem = this.activeMarket[item];

                if (activeItem) {
                    let dataset = {
                        label: this.getCommodityProperty({
                            key: item,
                            property: "text"
                        }).replace("&amp;", "&"),
                        backgroundColor: this.getCommodityProperty({
                            key: item,
                            property: "color"
                        }),
                        borderColor: this.getCommodityProperty({
                            key: item,
                            property: "color"
                        }),
                        data: [],
                        fill: false
                    };

                    for (var year = 1; year <= this.marketDataYears; year++) {
                        if (this.showQty) {
                            dataset.data.push(
                                activeItem[`year_${year}_quantity`]
                            );
                        } else {
                            dataset.data.push(activeItem[`year_${year}_value`]);
                        }
                    }

                    this.config.data.datasets.push(dataset);
                }
            });

            let yAxesLabel = window.mgChart.options.scales.yAxes[0];

            if (this.showQty) {
                if (this.marketDataMode == "GIAF-eq" || this.marketDataMode == "corn-eq") {
                    yAxesLabel.scaleLabel.labelString = `Qty or Corn Equivalent (MT)`;
                } else {
                    yAxesLabel.scaleLabel.labelString = `Quantity (${
                        this.activeUnit
                    })`;
                }
            } else {
                yAxesLabel.scaleLabel.labelString = `Value`;
            }

            window.mgChart.update();
        },
        addChartLabels() {
            if (!this.marketYear) return;
            const labels = [
                `${this.marketYear - 6}/${this.marketYear - 5}`,
                `${this.marketYear - 5}/${this.marketYear - 4}`,
                `${this.marketYear - 4}/${this.marketYear - 3}`,
                `${this.marketYear - 3}/${this.marketYear - 2}`,
                `${this.marketYear - 2}/${this.marketYear - 1}`
            ];
            this.config.data.labels = labels;
        },
        checkLocationParam() {
            const locationParam = getQueryParam("location");
            if (this.type == "commodities" && locationParam) {
                this.setSelectedMarket(locationParam);
            }
        },
        chartInit() {
            const chart = document.querySelector("#market-data-chart");

            if (!chart) return;

            const ctx = chart.getContext("2d");
            window.mgChart = new Chart(ctx, this.config);
        }
    },
    created() {
        this.setMarketDataView(this.type);
        this.checkLocationParam();
    },
    mounted() {
        this.chartInit();
    }
};
</script>

<style scoped>
canvas {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/js/vue-components/market-data-chart.vue